import Axios from 'axios';
import { Release } from '../types/release.types';

// Create a separate axios instance for public API calls (without auth headers)
const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || "/api";
const publicApi = Axios.create({ 
  baseURL: BASE_API_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

export interface ApiResponse<T> {
  code: number;
  message: string;
  data: T;
}

export const releaseApi = {
  getAllReleases: async (): Promise<ApiResponse<Release[]>> => {
    const response = await publicApi.get('/releases');
    return response.data;
  },

  downloadRelease: async (id: string): Promise<ApiResponse<{ downloadUrl: string; filename: string; version: string }>> => {
    const response = await publicApi.get(`/releases/${id}/download`);
    return response.data;
  }
};
